import { createSlice } from '@reduxjs/toolkit';

import { printBimehNamehMadaniById } from 'Feature/Asansour/Estelam/Actions/action';
import { printBimehNamehAtashsooziById } from 'Feature/Atashsoozi/EstelamAndSodoor/Action/action';
import InsuranceProductType from 'Feature/Common/Common/Types/Enums/InsuranceProductType';
import { printBimehNamehHadesehEnferadiById } from 'Feature/Hadeseh/Estelam/Actions/action';
import printBimehNamehShakhsSalesById from 'Feature/Khodro/ShakhsSales/Thunks/printBimehNamehShakhsSalesById';
import { printBimehNamehMosaferatiById } from 'Feature/Mosaferati/Estelam/Actions/action';
import { getAllOrderHistoriesByCurrentUserPagedFilter } from 'Feature/Orders/OrderHistories/Actions/action';
import { PageSizing } from 'Shared/Core/Common/Options/PageSizing';

import { IOrderHistoryState } from './model';

const initialState: IOrderHistoryState = {
  loading: false,
  orderHistories: {
    loading: false,
    data: {
      totalCount: 0,
      pageSize: PageSizing[1].value as number,
      queryResult: null,
    },
    queryParams: {
      orderDate: null,
      status: null,
      totalPrice: null,
      isExpired: null,
      insuranceProductType: null,
      pageNumber: 1,
      pageSize: 10,
      needTotalCount: true,
      sortAscending: false,
      sortBy: null,
    },
    pagination: {
      currentPage: 1,
      tableColumn: 0,
      totalPage: 0,
      customPageSize: PageSizing[1].value as number,
      firstItemNumber: 0,
      lastItemNumber: 0,
    },
  },
};

export const orderHistorySlice = createSlice({
  name: 'landing/orderHistories',
  initialState,
  reducers: {
    setOrderHistoriesTotalPage: (state, action) => {
      state.orderHistories.pagination.totalPage = action.payload;
    },
    setOrderHistoriesNextPage: (state) => {
      if (state.orderHistories.pagination.currentPage < state.orderHistories.pagination.totalPage) {
        state.orderHistories.pagination.currentPage = state.orderHistories.pagination.currentPage + 1;
        state.orderHistories.queryParams.pageNumber = state.orderHistories.pagination.currentPage;
      }
    },
    setOrderHistoriesPervPage: (state) => {
      if (state.orderHistories.pagination.currentPage > 1) {
        state.orderHistories.pagination.currentPage = state.orderHistories.pagination.currentPage - 1;
        state.orderHistories.queryParams.pageNumber = state.orderHistories.pagination.currentPage;
      }
    },
    setOrderHistoriesFirstPage: (state) => {
      state.orderHistories.pagination.currentPage = 1;
      state.orderHistories.queryParams.pageNumber = state.orderHistories.pagination.currentPage;
    },
    setOrderHistoriesEndPage: (state) => {
      state.orderHistories.pagination.currentPage = state.orderHistories.pagination.totalPage;
      state.orderHistories.queryParams.pageNumber = state.orderHistories.pagination.currentPage;
    },
    setOrderHistoriesCurrentPage: (state, action) => {
      state.orderHistories.pagination.currentPage = action.payload;
      state.orderHistories.queryParams.pageNumber = state.orderHistories.pagination.currentPage;
    },
    setOrderHistoriesCustomPageSize: (state, action) => {
      state.orderHistories.pagination.customPageSize = action.payload;
      state.orderHistories.queryParams.pageSize = state.orderHistories.pagination.customPageSize;
    },
    setGetAllOrderHistoriesByCurrentUserPagedFilterParams: (state, action) => {
      state.orderHistories.queryParams.status = action.payload.status;
      if (action.payload.insuranceProductType)
        state.orderHistories.queryParams.insuranceProductType =
          InsuranceProductType[action.payload?.insuranceProductType?.toString() as keyof typeof InsuranceProductType] ??
          null;

      state.orderHistories.queryParams.pageNumber = action.payload.pageNumber;
      state.orderHistories.queryParams.sortAscending = action.payload.sortAscending;
      state.orderHistories.queryParams.sortBy = action.payload.sortBy;
      state.orderHistories.pagination.currentPage = action.payload.pageNumber;
    },
    clearGetAllOrderHistoriesByCurrentUserPagedFilterParams: (state) => {
      state.orderHistories.queryParams = initialState.orderHistories.queryParams;
    },
    setFirstItemNumber: (state, action) => {
      state.orderHistories.pagination.firstItemNumber = action.payload;
    },
    setLastItemNumber: (state, action) => {
      state.orderHistories.pagination.lastItemNumber = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAllOrderHistoriesByCurrentUserPagedFilter.pending, (state) => {
        state.orderHistories.loading = true;
      })
      .addCase(getAllOrderHistoriesByCurrentUserPagedFilter.fulfilled, (state, action) => {
        state.orderHistories.loading = false;
        if (action.payload !== undefined) {
          state.orderHistories.data = action.payload;
        }
        return state;
      })
      .addCase(getAllOrderHistoriesByCurrentUserPagedFilter.rejected, (state) => {
        state.orderHistories.loading = false;
      });
    builder
      .addCase(printBimehNamehAtashsooziById.pending, (state) => {
        state.loading = true;
      })
      .addCase(printBimehNamehAtashsooziById.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(printBimehNamehAtashsooziById.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(printBimehNamehShakhsSalesById.pending, (state) => {
        state.loading = true;
      })
      .addCase(printBimehNamehShakhsSalesById.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(printBimehNamehShakhsSalesById.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(printBimehNamehHadesehEnferadiById.pending, (state) => {
        state.loading = true;
      })
      .addCase(printBimehNamehHadesehEnferadiById.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(printBimehNamehHadesehEnferadiById.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(printBimehNamehMosaferatiById.pending, (state) => {
        state.loading = true;
      })
      .addCase(printBimehNamehMosaferatiById.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(printBimehNamehMosaferatiById.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(printBimehNamehMadaniById.pending, (state) => {
        state.loading = true;
      })
      .addCase(printBimehNamehMadaniById.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(printBimehNamehMadaniById.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {
  setOrderHistoriesTotalPage,
  setOrderHistoriesNextPage,
  setOrderHistoriesPervPage,
  setOrderHistoriesFirstPage,
  setOrderHistoriesEndPage,
  setOrderHistoriesCurrentPage,
  setOrderHistoriesCustomPageSize,
  setGetAllOrderHistoriesByCurrentUserPagedFilterParams,
  clearGetAllOrderHistoriesByCurrentUserPagedFilterParams,
  setFirstItemNumber,
  setLastItemNumber,
} = orderHistorySlice.actions;

export default orderHistorySlice.reducer;
